/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * UC Monitoring API
 * UC Monitoring: Call Quality + Room Utilization
 * OpenAPI spec version: 1.0
 */

/**
 * Attendee type
 */
export type CalendarAttendeeType = (typeof CalendarAttendeeType)[keyof typeof CalendarAttendeeType];

export const CalendarAttendeeType = {
  REQUIRED: 'required',
  OPTIONAL: 'optional',
  RESOURCE: 'resource',
} as const;
